// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { SYSTEM } from '../internal/environment';
import customCssProps from '../internal/generated/custom-css-properties';
export function getLinkStyles(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let properties = {};
    if ((style === null || style === void 0 ? void 0 : style.root) && SYSTEM === 'core') {
        properties = {
            ...(((_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.color) && {
                [customCssProps.styleColorActive]: (_b = style.root.color) === null || _b === void 0 ? void 0 : _b.active,
                [customCssProps.styleColorDefault]: (_c = style.root.color) === null || _c === void 0 ? void 0 : _c.default,
                [customCssProps.styleColorHover]: (_d = style.root.color) === null || _d === void 0 ? void 0 : _d.hover,
            }),
            ...(((_e = style.root) === null || _e === void 0 ? void 0 : _e.focusRing) && {
                [customCssProps.styleFocusRingBorderColor]: (_f = style.root.focusRing) === null || _f === void 0 ? void 0 : _f.borderColor,
                [customCssProps.styleFocusRingBorderRadius]: (_g = style.root.focusRing) === null || _g === void 0 ? void 0 : _g.borderRadius,
                [customCssProps.styleFocusRingBorderWidth]: (_h = style.root.focusRing) === null || _h === void 0 ? void 0 : _h.borderWidth,
            }),
        };
    }
    return properties;
}
//# sourceMappingURL=style.js.map